module.exports = __webpack_public_path__ + "static/climatisation1-f545dcd747d645e98cecd9b53aad2128.jpg";